import React, { memo } from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import { ButtonGradient } from 'components/Button'
import { gradientBackgroundText } from '../../../styles/gradients'
import Image from '../../Image'
import { universalLink } from 'constants/mobile-app'
import { containerDefaultStyles } from 'styles/defaults'
import { trackGetApp } from 'tracking/pixel'
import colors from 'styles/colors'
import SendLinkForm from 'components/form-components/SendLinkForm'

const Section = styled.section`
  position: relative;
  background-color: ${colors.grayLightBg};
`

const Container = styled.div`
  ${containerDefaultStyles};

  ${mediaQuery.desktopMin} {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  ${mediaQuery.bigTabletMin} {
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  ${mediaQuery.tablet} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${mediaQuery.mobile} {
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
  }
`

const TitleCol = styled.div`
  flex: 0 0 400px;

  ${mediaQuery.tabletMax} {
    text-align: center;
  }
`

const ImageCol = styled.div`
  flex: 0 1 350px;
  padding: 0 15px;

  ${mediaQuery.tablet} {
    width: 300px;
    max-width: 100%;
    margin: 0 auto 40px;
  }

  ${mediaQuery.mobile} {
    width: 210px;
    max-width: 100%;
    margin: 0 auto 20px;
  }
`

const LinksCol = styled.div`
  flex: 0 0 290px;
  padding: 0 15px;

  ${mediaQuery.tabletMax} {
    text-align: center;
    padding: 0;

    & br {
      display: none;
    }
  }
`

const PhoneImage = styled(Image).attrs({
  fileName: 'home-section-1/section1-phone.png',
  alt: 'phone',
})`
  width: 100%;
`

const FormWrap = styled.div``

const Title = styled.h1`
  font-size: 57px;
  position: relative;
  margin-bottom: 40px;
  line-height: 1.2;
  ${gradientBackgroundText};

  ${mediaQuery.mobile} {
    font-size: 28px;
    line-height: 38px;
    width: 300px;
    max-width: 100%;
    margin: 0 auto 20px;

    & > br {
      display: none;
    }
  }
`

const Subtitle = styled.h4`
  font-size: 26px;
  line-height: 38px;
  margin-bottom: 40px;
  font-weight: 500;

  ${mediaQuery.tabletMax} {
    width: 400px;
    max-width: 100%;
    margin: 0 auto 40px;
  }

  ${mediaQuery.mobile} {
    font-size: 20px;
    line-height: 30px;
    font-weight: 400;
    margin-bottom: 20px;
  }
`

const Button = styled(ButtonGradient)`
  position: relative;
  width: 100%;
  height: 70px;
  border-radius: 35px;
  display: ${({ tabletMax }) => (tabletMax ? 'none' : 'flex')};

  ${mediaQuery.tabletMax} {
    display: ${({ tabletMax }) => (tabletMax ? 'flex' : 'none')};
    height: 50px;
    border-radius: 25px;
    width: 260px;
    max-width: 100%;
    margin: 0 auto 20px;
  }

  & > span {
    font-size: 18px;
    line-height: 30px;
    font-weight: bold;
    display: block;
  }

  &:after {
    border-radius: 35px;
  }
`

const LinksTitle = styled.h6`
  font-size: 26px;
  line-height: 37px;
  font-weight: 500;
  margin-bottom: 40px;

  ${mediaQuery.tabletMax} {
    font-size: 15px;
    margin-bottom: 15px;
  }
`

const HomeSection1 = () => (
  <Section>
    <Container>
      <TitleCol>
        <Title>
          Beauty <br />
          Shopping. <br />
          Reinvented.
        </Title>
        <Subtitle>
          The app that lets you experience the next era of shopping for beauty
          products.
        </Subtitle>
        <Button as="a" href={universalLink} onClick={trackGetApp}>
          <span>TRY IT TODAY</span>
        </Button>
      </TitleCol>
      <ImageCol>
        <PhoneImage />
      </ImageCol>
      <Button as="a" href={universalLink} onClick={trackGetApp} tabletMax>
        <span>TRY IT TODAY</span>
      </Button>
      <LinksCol>
        <LinksTitle>
          <b>Join Flip today!</b>
          <br /> Get the app on
        </LinksTitle>
        <FormWrap>
          <SendLinkForm />
        </FormWrap>
      </LinksCol>
    </Container>
  </Section>
)

export default memo(HomeSection1)
